<template>
  <div id="app">
    
    <div v-show="curld==0">
      <div class="head">
        <span class="name">中国电信</span>
        <span class="boldLine"></span>
        <span class="lightLine"></span>
      </div>      
      <div class="title">套餐内容</div>
      <p class="content">
        1.国内流量畅享，校园50GB基站流量<br>
        2.当月国内手机上网流量达到40GB降速阈值后，上网速率降至1Mbps，次月恢复<br>
        3.国内可通用电话时长300分钟，全国接听免费，校园1000分钟打三网免费<br>
        4.免费附赠200M电信宽带（闪讯），可访问校园学术资源        
      </p>
      <div class="title">学生优惠</div>
      <p class="content">
        1.新入网用户享5/6/7/8四个月免费<br>
        2.电信号码注册翼支付立得20话费券，每月可领取60-30代金券，指定日期支付即可获得10元代金券。 
        开学1元可购买生活用品（一箱牛奶，床头篮，运动水杯等视各校情况而定）。8月更有存30得60活动。<br>
        3.宽带实际能享受上网速率视学校网络资源情况而定，可咨询学校附近的中国电信校园营业厅            
      </p>
      <div class="tip">如果你想办理，请长按扫描下方二维码</div>
      <img src='./assets/dianxin.jpg' width="100px" align="center">
      <p></p>
    </div>

    <div v-show="curld==1">
      <div class="head">
        <span class="name">中国移动</span>
        <span class="boldLine"></span>
        <span class="lightLine"></span>
      </div>      
      <div class="title">套餐内容</div>
      <p class="content" >
        1.全国流量放心用40GB +校区流量50GB +抖音头条系流量15GB +网易系流量15GB+250小时校园WLAN时长<br>
        2.1430分钟电话优惠，含1000分钟省校区拨打全国移动+300分钟全国任意地区拨打全国移动+100分钟省校区拨打全国+30分钟杭州地区拨打全国<br>
        3. 200兆免费宽带，断电不断网，可连路由器，密码固定，连上杭电校园VPN，校园内网资源一步搞定
      </p>
      <div class="title">学生优惠</div>
      <p class="content">
        1.新入网用户享6/7/8/9四个月免费<br>
        2.预缴100元到账120元话费<br>
        3.线上办理前1000位赠送价值两百元的乌镇一日游         
      </p>
      <div class="tip">如果你想办理，请长按扫描下方二维码</div>
      <img src="./assets/yidong.jpg" width="100" height="100">
      <p></p>
    </div>

    <div v-show="curld==2">
      <div class="head">
        <span class="name">中国联通</span>
        <span class="boldLine"></span>
        <span class="lightLine"></span>
      </div>      
      <div class="title">套餐内容</div>
      <p class="content">
        1.全国流量60GB不限速<br>
        2.全省高校校区内放心用，50GB后限速7.2M/S，100GB后限速1M/S<br>
        3.全国接听免费+120分钟全国通话时长+2000分钟虚拟网内通话时长<br>
        4.部分可办理开通高速宽带。全部可安装路由器，共享wifi
      </p>
      <div class="title">学生优惠</div>
      <p class="content">
        此套餐为新生特惠，原月租46元/月，现资费28元/月<br>
        新生选号后缴费150元将在实名激活后立即到账，可查可抵扣月租，即每月实扣月租18
      </p>
      <div class="tip">如果你想办理，请长按扫描下方二维码</div>
      <img src="./assets/liantong.jpg" width="100px" height="100px">
    
    </div>
    
    
    <div class="tabBar">       
        <span  v-for="(item,index) in list" :key="item.index" v-bind:class="{active:index===curld,notActive:index!=curld}" @click="change(index)"  >
          {{item.name}}
        </span>      
    </div>
  </div>
</template>


<script>


export default {
  name: 'App',
  components: {
    
  },
  data(){
    return {
      curld:0,
      list:[
        {name:"电信"},
        {name:"移动"},
        {name:"联通"}
      ],
    }
  },
  methods:{ 
    change:function(index){
      this.curld=index;   
    }
 }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue